import { render, staticRenderFns } from "./Codm.vue?vue&type=template&id=ebc982fc&scoped=true"
import script from "./Codm.vue?vue&type=script&lang=js"
export * from "./Codm.vue?vue&type=script&lang=js"
import style0 from "./Codm.vue?vue&type=style&index=0&id=ebc982fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc982fc",
  null
  
)

export default component.exports